import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { requestHostScrollTop } from '../../utils/helpers';

class ScrollToTop extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    children: PropTypes.element.isRequired,
  };

  componentDidMount() {
    // Not only on route changes: this app is also *arrived at* inside a frame.
    // The ticket flow on linky.biz hands the buyer over to /paynow by
    // navigating the frame it is in, so our first page is a fresh document in
    // a frame the host has left scrolled to wherever the Next button was —
    // near the bottom of the page that was there a moment ago. Nothing in this
    // document has moved, so componentDidUpdate never runs and only this asks
    // for the frame's top edge.
    requestHostScrollTop();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);

      // The scroll above moves nothing when a host has sized our frame to our
      // own content: there is no frame scroll left. The buyer is still
      // wherever the host page was left, which is now the middle of the page
      // they just opened, so ask the host to scroll instead.
      requestHostScrollTop();
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default withRouter(ScrollToTop);
